import {v4 as uuidv4} from "uuid";
import {AnalyticsService} from "../services/analytics-service";
import ServiceLocator from "../services/service-locator";
import Form from "./forms/form";

export default class ConsultationStaticForm {
    constructor() {
        this.sl = ServiceLocator.instance;

        if (!document.getElementById('consultation-static')) {
            return;
        }

        this.init();
    }

    init() {
        this.consultationForm = new Form({
            formId: 'consultation-static',
            uri: '/2.0/courses/registration',
            data: {
                type: 'consultation',
                branding: 'bookford',
                fbp: costorage.get('_fbp') ? costorage.get('_fbp') : null,
                fbc: costorage.get('_fbc') ? costorage.get('_fbc') : null,
                referrer: location.href
            },
            subscriptions: [
                {
                    event: 'beforeSubmit',
                    callback: () => {
                        const courseLang = this.sl.courseLang;
                        const conversionId = uuidv4();
                        const owoxUserId = costorage.get('ouid');


                        if (courseLang) {
                            this.consultationForm.addData({ courseLang });
                        }

                        this.consultationForm.addData({ conversionId });

                        if (owoxUserId) {
                            this.consultationForm.addData({ owoxUserId });
                        }

                        if (craft.page.courseDirectoryId) {
                            this.consultationForm.addData({ course: craft.page.courseDirectoryId });
                        }

                        const dataLayerEventData = {
                            event: 'free_consultation_footer_form',
                            formId: this.consultationForm.formId,
                            phone: this.consultationForm.data.tel,
                            email: this.consultationForm.data.email,
                            conversion_id: conversionId
                        };

                        AnalyticsService.sendEvent('free_consultation_form', dataLayerEventData);
                    }
                },
                {
                    event: 'submitComplete',
                    callback: () => {
                        costorage.set('h_consultationRequested', 1, {
                            expires: 45 * 24 * 60 * 60,
                            domain: '.bookford.com',
                            path: "/"
                        });
                    }
                }
            ]
        });
    }
}